import { render } from "./JoinUs.vue?vue&type=template&id=6eec4662"
import script from "./JoinUs.vue?vue&type=script&lang=js"
export * from "./JoinUs.vue?vue&type=script&lang=js"
script.render = render

export default script